(function () {
    'use strict';

    angular
        .module('app.blogPost')
        .factory('PostMediasService', Service);

    Service.$inject = ['$http', '$q', 'Settings', 'ngAuthSettings', 'logger', 'config', 'MediaService'];

    function Service($http, $q, Settings, ngAuthSettings, logger, config,  MediaService) {
        var service = {
            getAll: getAll,
            get: get,
            add: add,
            edit: edit,
            del: del,
            getFields: getFields
        };

        var serviceBase = ngAuthSettings.apiServiceBaseUri + 'api/Post/';

        var fields = [
            {
                key: "MediaId",
                type: "horizontalSingleImage",
                templateOptions: {
                    label: "Resim",
                    resource: 'form.image',
                    valueModel: "Media.FileName"
                }
            },
            {
                key: 'DisplayOrder',
                type: 'horizontalInput',
                templateOptions: {
                    type: 'number',
                    resource: 'form.display-order',
                    label: 'Sıra',
                    placeholder: 'Sıra'
                }
            },
            {
                key: 'IsMain',
                type: 'horizontalCheckbox',
                templateOptions: {
                    label: 'Ana Resim',
                    resource: 'form.is-main-media',
                    placeholder: 'Ana Resim'
                }
            },
            {
                key: 'ShowSlider',
                type: 'horizontalCheckbox',
                templateOptions: {
                    label: 'Sliderda Göster',
                    resource: 'form.show-slider',
                    placeholder: 'Sliderda Göster'
                }
            }
        ];

        return service;

        /////////////////////////////////////////

        function getFields() {
            return fields;
        }

        function getAll(PostId) {
            var url = serviceBase + PostId + '/PostMedia';
            var deferred = $q.defer();

            $http.get(url)
                .then(getComplete)
                .catch(getFailed);

            function getComplete(response) {
                deferred.resolve(response.data);
            }

            function getFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function get(Id) {
            var deferred = $q.defer();

            $http.get(serviceBase + Id)
                .then(getProductComplete)
                .catch(getProductFailed);

            function getProductComplete(response) {
                deferred.resolve(response.data);
            }

            function getProductFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function add(entity) {
            var url = serviceBase + entity.PostId + "/PostMedia";
            var deferred = $q.defer();

            $http.post(url, entity)
                .then(addComplete)
                .catch(addFailed);

            function addComplete(response) {
                deferred.resolve(response.data);
            }

            function addFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function edit(entity) {
            var url = serviceBase + entity.PostId + "/PostMedia";
            var deferred = $q.defer();

            $http.put(url, entity)
                .then(editComplete)
                .catch(editFailed);

            function editComplete(response) {
                deferred.resolve(response.data);
            }

            function editFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }

        function del(entity) {
            var deferred = $q.defer();

            $http.delete(serviceBase, entity)
                .then(deleteComplete)
                .catch(deleteFailed);

            function deleteComplete(response) {
                deferred.resolve(response.data);
            }

            function deleteFailed(error) {
                deferred.reject(error);
            }
            return deferred.promise;
        }
    }
})();